import type { FaireProductEntity } from "../../entity_types/product";

export const p_4k7nd38ket: FaireProductEntity = {
  token: "p_4k7nd38ket",
  type: "product",
  name: "Sweet Ghost Halloween Grosgrain Bow Clip - Hair Accessories",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/60b61f0a5d2498b3f007e57c256d91849f63a50e0974003fa1b03f7dfd46aa47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69e3a00148005807aaccdab35170797f1bec98c303cebb2dd312680e6f9b06a4.jpeg",
    "https://cdn.faire.com/fastly/aed6939b9d74cfc1f1ed44c92a403633a251d31387acf6c49477b5702b2422bc.jpeg",
    "https://cdn.faire.com/fastly/2ebf2a9c4726a0f657e2063883b691beb669bbc8b3eb62964ea93d4ed00e98af.jpeg",
    "https://cdn.faire.com/fastly/2cdc685765c2da695760b06310892d19e46df92d8cf6413cd1be38c6776f9a3b.jpeg",
    "https://cdn.faire.com/fastly/044b41054d5c15bbd0ba1ab5e06ccb2d1c175a14faf07ef202e702e24fbd6a4d.jpeg",
    "https://cdn.faire.com/fastly/4d5fa3c52b632bff0a587c4c5496209bc99ee7c3cfaeea0a122982b26f3b3cdc.jpeg",
    "https://cdn.faire.com/fastly/65f50135dd44a130c029a98c5f15d123159447b69cba7cf041ce4e0afa5f7396.jpeg",
  ],
  priceDollars: 5,
  description:
    'Sweet with just a hint of spooky, this darling bow clip adds the cutest ghostly touch to all her Halloween outfits.\n\nFeatures:\n * Soft pink bow with a white ghost motif and black satin bow accent \n * Ribbon-covered alligator clip to grip the hair \n * Glitter accents are "shed free" \n * One size fits all \n\nPair this hair clip with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:31.191Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
